export default __webpack_public_path__ + "static/media/SAPC-Logo-yellow.f7981ab8.png";